module.exports = __webpack_public_path__ + "media/images/prijavaff7022-9c14c296.svg";